<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z06xe3/tc-custom/9781466860728.jpg?1731796824824" alt="This image is the cover for the book Taste for Nightshade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taste for Nightshade
      </h1>
      <p class="bookDescription body article font2">
        <p>Manchester  1809. When budding young criminal Mary Jebb swindles Michael Croxton's  brother with a blank pound note, he chases her into the night and sets  in motion a train of sinister events. Condemned to seven years of  transportation to Australia, Mary sends him a 'Penny Heart'-a token of  her vow of revenge.<br/><br/>Two years later, Michael marries naïve young  Grace Moore. Although initially overjoyed at the union, Grace quickly  realizes that her husband is more interested in her fortune than her  company. Lonely and desperate for companionship, she turns to her new  cook to help mend her ailing marriage. But Mary Jebb, shipwrecked,  tortured, and recently hired, has different plans for the unsuspecting  owners of Delafosse Hall.<br/><br/><i>A Taste for Nightshade</i> is a  thrilling historical novel that combines recipes, mystery and a dark  struggle between two desperate women, sure to appeal to fans of Sarah  Waters and Carolly Erickson.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martine Bailey
      </h2>
      
      <p class="authorDescription body article">MARTINE BAILEY is the author of <I>An Appetite for Violets</I>. As an  amateur cook, she won the Merchant Gourmet Recipe Challenge and was a  former UK Dessert Champion, cooking at Le Meurice in Paris. Her recipes  have appeared in many publications including <I>Good Housekeeping, Olive Magazine </I>and<I> Green and Black's Chocolate Recipes</I>. Martine lives in Cheshire, England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c6d3e78